module.exports = __webpack_public_path__ + "img/gold-badge-48px.b171aef4.png";